import React from 'react';
export const CFIconActivity = {
    alias: 'activity',
    defaultTitle: 'Activity',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M14.329 20a1.78 1.78 0 0 1-.205-.01c-.88-.086-1.57-.707-1.76-1.582L9.681 6.016l-2.763 6.382c-.159.366-.52.603-.918.603H3a1 1 0 1 1 0-2h2.344L7.85 5.21c.355-.815 1.137-1.29 2.026-1.201.88.087 1.57.708 1.76 1.583l2.683 12.392 2.763-6.382A1 1 0 0 1 18 11h3a1 1 0 1 1 0 2h-2.344l-2.506 5.788A1.968 1.968 0 0 1 14.329 20Z' }))),
};
